// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".orders-edit__timeline-btn{top:7.5rem!important;z-index:3!important;border-top-right-radius:0;border-bottom-right-radius:0;right:0!important}.orders-edit__controls{z-index:3!important}", ""]);
// Exports
module.exports = exports;
